<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        style="position: relative"
      >
        <el-form-item
          label="是否启用"
          prop="IsQy"
        >
          <el-switch
            v-model="state.model.IsQy"
            inline-prompt
            active-text="启用"
            inactive-text="停用"
          />
        </el-form-item>
        <el-form-item
          label="分类名称"
          prop="Mc"
          :rules="[{ required: true, message: '请输入分类名称', trigger: 'blur' }]"
        >
          <el-input
            v-model="state.model.Mc"
            placeholder="如：景区门票、特惠套餐、热门酒店等"
          />
        </el-form-item>
        <el-form-item label="排序号" prop="Xh">
          <el-input-number
            v-model="state.model.Xh"
            :min="0"
            :max="9999"
            placeholder="数字越小越靠前"
          />
        </el-form-item>
        <el-form-item label="查看更多" prop="CkGd">
          <el-input
            v-model="state.model.CkGd"
            placeholder="如：/pages/products/index?category=ticket"
          />
        </el-form-item>
        <el-form-item label="关联商品" prop="SpIds">
          <div style="width: 100%">
            <!-- 已选商品列表 -->
            <div v-if="state.model.SpItems && state.model.SpItems.length > 0" style="margin-bottom: 12px">
              <el-tag
                v-for="(item, index) in state.model.SpItems"
                :key="item.Id || item.SpId"
                closable
                style="margin: 0 8px 8px 0"
                @close="onRemoveSp(index)"
                type="info"
              >
                {{ item.SpMc || item.Mc || '商品' + item.SpId }}
              </el-tag>
            </div>
            <!-- 搜索并选择商品 -->
            <div style="display: flex; gap: 8px; margin-bottom: 8px; flex-wrap: wrap; align-items: center">
              <el-select
                v-model="state.spPlMc"
                placeholder="关联分类"
                style="width: 140px"
                clearable
              
              >
                <el-option label="旅游商品" value="旅游商品" />
                <el-option label="酒店" value="酒店" />
                <el-option label="门票" value="门票" />
                <el-option label="组合商品" value="4" />
              </el-select>
              <el-input
                v-model="state.spSearchKey"
                placeholder="搜索商品名称"
                style="width: 180px"
                clearable
                @keyup.enter="onSearchSp(1)"
              />
              <el-button type="primary" @click="onSearchSp(1)" :loading="state.spLoading">
                查询
              </el-button>
            </div>
            <!-- 商品选择表格 -->
            <div v-if="state.spTableData && state.spTableData.length > 0" style="position: relative">
              <el-table
                :data="state.spTableData"
                :max-height="260"
                style="width: 800px"
                size="small"
                @selection-change="onSpSelectionChange"
                ref="spTableRef"
              >
                <el-table-column type="selection" width="35" />
                <el-table-column label="封面" width="55">
                  <template #default="{ row }">
                    <el-image
                      v-if="row.Fm"
                      :src="row.Fm"
                      style="width: 40px; height: 28px"
                      fit="cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="Mc" label="商品名称" min-width="140" />
                <el-table-column prop="PlMc" label="品类" width="70" />
              </el-table>
              <!-- 加载更多 -->
              <div v-if="state.spHasMore" style="text-align: center; padding: 10px 0">
                <el-button
                  size="small"
                  :loading="state.spLoadingMore"
                  @click="onLoadMoreSp"
                  link
                  type="primary"
                >加载更多...</el-button>
              </div>
            </div>
            <div v-else-if="(state.spSearchKey || state.spPlMc) && !state.spLoading" style="color: #999; font-size: 13px">
              未搜索到商品，请尝试其他关键词
            </div>
            <div style="color: #999; font-size: 12px; margin-top: 4px">
              选择关联分类或输入关键词搜索商品，勾选后自动添加到已选列表
            </div>
          </div>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref, computed, nextTick } from "vue";
import { homefenlei_detail, homefenlei_add, homefenlei_edit, homefenlei_splist } from "@/http/api";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const spTableRef = ref(null);
    const state = reactive({
      model: {
        IsQy: true,
        Xh: 0,
        SpItems: [],
      },
      spSearchKey: "",
      spPlMc: "",
      spPageIndex: 1,
      spPageSize: 30,
      spTotalCount: 0,
      spTableData: null,
      spLoading: false,
      spLoadingMore: false,
      selectRows: [],
    });

    const initSelectedSpIds = ref([]);

    onMounted(() => {
      if (props.id) {
        homefenlei_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data;
            if (res.data.SpItems) {
              state.model.SpItems = res.data.SpItems;
              initSelectedSpIds.value = res.data.SpItems.map(m => m.SpId);
            }
          }
        });
      }
    });

    // spHasMore 计算属性
    const spHasMore = computed(() => {
      return state.spTableData && state.spTableData.length < state.spTotalCount;
    });

    // 搜索商品（pageIndex=1 重新搜索）
    const onSearchSp = (pageIndex) => {
      state.spLoading = true;
      state.spPageIndex = pageIndex || 1;

      const params = {
        key: state.spSearchKey || undefined,
        plMc: state.spPlMc || undefined,
        pageIndex: state.spPageIndex,
        pageSize: state.spPageSize,
      };

      homefenlei_splist(params).then((res) => {
        state.spLoading = false;
        state.spLoadingMore = false;
        if (res.status == 200) {
          const data = Array.isArray(res.data) ? res.data : (res.data?.list || []);
          const count = res.data?.count || data.length;

          if (state.spPageIndex === 1) {
            state.spTableData = data;
          } else {
            state.spTableData = [...(state.spTableData || []), ...data];
          }
          state.spTotalCount = count;

          // 回显已选中的
          nextTick(() => {
            if (spTableRef.value && state.model.SpItems) {
              const selectedIds = state.model.SpItems.map(m => m.SpId);
              state.spTableData.forEach(row => {
                if (selectedIds.includes(row.Id)) {
                  spTableRef.value.toggleRowSelection(row, true);
                }
              });
            }
          });
        }
      });
    };

    // 加载更多
    const onLoadMoreSp = () => {
      if (state.spLoadingMore) return;
      state.spLoadingMore = true;
      state.spPageIndex++;
      onSearchSp(state.spPageIndex);
    };

    // 选中商品变化
    const onSpSelectionChange = (rows) => {
      // 合并已选中的和本次选中的
      const existIds = state.model.SpItems.map(m => m.SpId);
      rows.forEach(row => {
        if (!existIds.includes(row.Id)) {
          state.model.SpItems.push({
            SpId: row.Id,
            SpMc: row.Mc,
            SpFm: row.Fm,
            Xh: state.model.SpItems.length,
          });
        }
      });
      // 移除取消勾选的
      const currentIds = rows.map(m => m.Id);
      state.model.SpItems = state.model.SpItems.filter(item => {
        // 保留 initial 加载的项
        if (initSelectedSpIds.value.includes(item.SpId)) {
          if (!currentIds.includes(item.SpId)) {
            initSelectedSpIds.value = initSelectedSpIds.value.filter(id => id !== item.SpId);
            return false;
          }
          return true;
        }
        return currentIds.includes(item.SpId);
      });
    };

    // 手动移除已选商品
    const onRemoveSp = (index) => {
      const removed = state.model.SpItems[index];
      state.model.SpItems.splice(index, 1);
      // 如果表格中有此行，取消选中
      if (spTableRef.value && state.spTableData) {
        const row = state.spTableData.find(r => r.Id === removed.SpId);
        if (row) spTableRef.value.toggleRowSelection(row, false);
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        const data = {
          Mc: state.model.Mc,
          Xh: state.model.Xh,
          IsQy: state.model.IsQy,
          CkGd: state.model.CkGd || null,
          SpIds: state.model.SpItems.map(m => m.SpId),
        };

        if (props.id) {
          homefenlei_edit(props.id, data).then((res) => {
            proxy.$post_response(res, emit);
          });
        } else {
          homefenlei_add(data).then((res) => {
            proxy.$post_response(res, emit);
          });
        }
      });
    };

    return {
      state,
      formDom,
      spTableRef,
      spHasMore,
      onSubmit,
      onSearchSp,
      onLoadMoreSp,
      onSpSelectionChange,
      onRemoveSp,
    };
  },
};
</script>

<style scoped lang="less">
</style>
